import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, withStyles, Paper, Button, Typography } from '@material-ui/core';
import PageTitle from '../../components/PageTitle/PageTitle';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../utils/common';

class TenantManager extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    // this.initData = this.initData;
    this.state = {
      userId: null,
      tenantsList: [],
      isCheckAll: false,
    };
  }

  async componentDidMount() {
    await this.props.tenant.getTenantsInfo();
    const userPath = this.props.location.pathname.replace('/app/users/', '');
    const userId = Number(userPath.replace('/tenant', ''));

    await this.props.user.getUserById(userId);
    this.setState({ userId });
    this.initData();
  }

  async initData() {
    const { userDetail } = this.props.user.toJS();
    const tenantPermission = JSON.parse(userDetail.tenantPermission);
    const { tenantsInfo } = this.props.tenant.toJS();

    const tenantsList = tenantsInfo.map((t) => {
      t.status = tenantPermission.length === 0 ? true : tenantPermission.includes(t.id) ? true : false;
      return t;
    });

    this.setState({
      tenantsList,
      isCheckAll:
        tenantPermission.length === 0
          ? true
          : tenantsList.length === (tenantsList || []).filter((t) => t.status === true).length
            ? true
            : false,
    });
  }

  goBack() {
    this.props.user.setAction('action', true);
    this.props.history.goBack();
  }

  expandList = (index) => {
    this.setState((prevState) => {
      prevState.expandIndex = prevState.expandIndex !== index ? (prevState.expandIndex = index) : null;
      return prevState;
    });
  };

  handleSelectAll = (e) => {
    let { tenantsList } = this.state;
    tenantsList.map((t) => {
      t.status = e.target.checked ? true : false;
      return t;
    });
    this.setState({
      isCheckAll: e.target.checked,
      tenantsList,
    });
  };

  handleChange = (e) => {
    let { tenantsList } = this.state;
    const { value, name, checked } = e.target;
    if (name === 'tenant') {
      tenantsList.map((val) => {
        if (+val.id === +value) {
          val.status = checked;
        }
        return val;
      });
    }
    const findStatus = tenantsList.find((item) => item.status === false);
    this.setState({
      ...this.state,
      tenantsList: tenantsList,
      isCheckAll: !findStatus ? true : false,
    });
  };

  handleSave = (id) => {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('manage_views')}`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: `${t('update')}`,
      cancelButtonText: `${t('cancel')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        const { tenantsList } = this.state;
        let data = {};
        const permissions = tenantsList.filter((t) => t.status === true).map((val) => val.id);
        data.id = id;
        data.tenantPermission = permissions;
        try {
          const result = await this.props.user.updateUser(data);
          if (result.statusCode === 200) {
            Swal.fire({ html: `<h4>${t('update_success')}`, type: 'success' }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                this.props.user.setAction('action', true);
                this.props.history.push('../../users');
              } else {
                Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
              }
            });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
          }
        }
      }
    });
  };

  render() {
    const { classes, t } = this.props;
    let { tenantsList, userId, isCheckAll } = this.state;
    const { loading } = this.props.tenant.toJS();
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('manage_tenant')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={12} style={{ display: tenantsList.length === 0 ? 'none' : '' }}>
              <div className={classes.headCard}>
                <FormControlLabel
                  aria-label='selectAll'
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                  control={
                    <Checkbox
                      name='selectAll'
                      id='selectAll'
                      onChange={(e) => this.handleSelectAll(e)}
                      color='primary'
                      checked={isCheckAll ? true : false}
                    />
                  }
                  label={t('select_all_tenants')}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} className={classes.listContain}>
              <div className={classes.expandRoot}>
                {(tenantsList || []).map((val) => (
                  <ExpansionPanel
                    className={classes.expansionPanel}
                    onChange={this.expandList.bind(null, val.id)}
                    expanded={this.state.expandIndex === val.id}
                    key={'expension' + val.id}
                  >
                    <ExpansionPanelSummary
                      className={classes.expansionPanelSummary}
                      // expandIcon={<ExpandMoreIcon />}
                      aria-label='Expand'
                      aria-controls='additional-actions1-content'
                      id={`expand-panel-tenant-${val.id}`}
                    >
                      <FormControlLabel
                        aria-label='group'
                        onClick={(event) => event.stopPropagation()}
                        onFocus={(event) => event.stopPropagation()}
                        key={val.id}
                        control={
                          <Checkbox
                            onChange={(e) => this.handleChange(e)}
                            value={val.id + ''}
                            name='tenant'
                            checked={val.status ? true : false}
                            color='primary'
                          />
                        }
                        label={<Typography>{val.name}</Typography>}
                      />
                    </ExpansionPanelSummary>
                  </ExpansionPanel>
                ))}
              </div>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.button}
                  onClick={() => this.handleSave(userId)}
                >
                  {t('save')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  spaceTop: {
    marginTop: '10px',
  },
  listContain: {
    marginLeft: theme.spacing.unit * 5,
  },
  buttons: {
    marginTop: '50px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: '5px',
  },
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  headCard: {
    width: '100%',
    padding: '12px 22px',
  },
  expandRoot: {
    width: '100%',
  },
  expansionPanel: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
    expanded: {},
  },
  expansionPanelSummary: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
    content: {
      '&$expanded': {
        margin: '5px 0',
      },
    },
    expanded: {},
  },
  expansionPanelDetails: {
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    padding: '8px 22px',
  },
  bodyMargin: {
    marginLeft: '20px',
  },
});

export const page = inject('subGroup', 'group', 'tenant', 'user')(observer(TenantManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
